import { makeChirpEarlyRequest } from 'rpc-client-utils';
import { getHydratedLessonEarlyRequestRpc } from '../__generated__/chirp/com/hubspot/academy/catalog/rpc/earlyRequest/LessonChirpService.early';
import { getAllFilterTypesEarlyRequestRpc } from '../__generated__/chirp/com/hubspot/academy/catalog/rpc/earlyRequest/FilterChirpService.early';
import quickFetch from 'quick-fetch';
import { getHydratedTrackEarlyRequestRpc } from '../__generated__/chirp/com/hubspot/academy/catalog/rpc/earlyRequest/TrackChirpService.early';
const pathname = window.location.pathname;
const lessonIdMatches = pathname.match(/lessons\/(\d+)/);
const trackIdMatches = pathname.match(/tracks\/(\d+)/);
const portalId = quickFetch.getPortalId();
if (portalId) {
  if (lessonIdMatches) {
    const lessonId = Number(lessonIdMatches[1]);
    void makeChirpEarlyRequest(getHydratedLessonEarlyRequestRpc, {
      request: {
        lessonId
      }
    });
  } else if (trackIdMatches) {
    const trackId = Number(trackIdMatches[1]);
    void makeChirpEarlyRequest(getHydratedTrackEarlyRequestRpc, {
      request: {
        trackId
      }
    });
  }
  void makeChirpEarlyRequest(getAllFilterTypesEarlyRequestRpc, {});
}